import {
    READ_LOCATION,
    READ_COMPETITION_CLASSIFICATIONS,
    READ_COMPETITION,
    READ_CLASSIFICATION_GPX_FILE,
    READ_DEVICES,
    CREATE_SESSION,
    DELETE_SESSION,
    READ_POSITIONS,
    UPDATE_AWARDED_DEVICES,
    READ_GEOFENCES,
    READ_COMPETITION_TRACKPOINTS,
    READ_PLAYERS,
    READ_SESSION,
    READ_SUMMARY_DEVICE,
    READ_ROUTE,
    BOOTSTRAP_MAP,
    READ_GEOJSON_REPLAY,
    READ_EVENT_TIMES_DATA,
} from './actions.type'
import { api, apiAP, apiDostartu } from '../api'
import { normalize } from 'normalizr'
import schema from '../api/schema'
import {
    SET_ENTITIES,
    SET_APP_STATUS,
    SET_USER_ID,
    SET_AWARDED_DEVICES,
    SET_GEOFENCES,
    SET_SELECTED_CLASSIFICATION_ID,
    SET_EVENT_TIMES_DATA,
    SET_SELECTED_SERIE_NUMBER,
} from './mutations.type'
import qs from 'qs'
import validateGPXFileFromURL from '@/utils/validateTrack'
export default {
    async [BOOTSTRAP_MAP]({ dispatch, getters, commit }, competitionId) {
        let [{ classifications }, playersIds] = await Promise.all([
            dispatch(READ_COMPETITION_CLASSIFICATIONS, competitionId),
            dispatch(READ_PLAYERS, competitionId),
            dispatch(READ_COMPETITION, competitionId),
            dispatch(READ_POSITIONS), //  Read list of last known positions
            dispatch(READ_COMPETITION_TRACKPOINTS, competitionId),
            dispatch(READ_GEOFENCES),
            dispatch(READ_EVENT_TIMES_DATA, competitionId)
        ])
        let devicesIds = []
        for (let id of playersIds) {
            devicesIds.push(getters.players[id].deviceId)
        }
        await dispatch(READ_DEVICES, { id: devicesIds })
        commit(SET_SELECTED_CLASSIFICATION_ID, classifications[0])
        let competitionClassifications = []
        for (let id of classifications) {
            competitionClassifications.push(getters.classifications[id])
        }
        const promises = []
        for (const trackpoint of getters.trackpointsBy(
            competitionClassifications
        )) {
            promises.push(dispatch(READ_LOCATION, trackpoint.location))
        }
        await Promise.all(promises)
        const gpxPromises = []
        for (const cls of competitionClassifications) {
            gpxPromises.push(dispatch(READ_CLASSIFICATION_GPX_FILE, cls.id))
        }
        await Promise.all(gpxPromises)
        let fromTime = getters.competitions[competitionId].startedTime.clone()
        await dispatch(READ_SUMMARY_DEVICE, {
            from: fromTime.subtract(2, 'h').toISOString(),
            to: new Date().toISOString(),
            deviceId: devicesIds,
        })
    },
    async [READ_DEVICES]({ commit }, query) {
        const data = await api.get(
            `/devices?${qs.stringify(query, { indices: false })}`
        )

        const normalized = normalize(data, [schema.device])

        commit(SET_ENTITIES, normalized.entities)

        return normalized.result
    },
    async [READ_SESSION]({ commit }) {
        const data = await api.get('/session')

        const normalized = normalize(data, schema.user)
        commit(SET_USER_ID, normalized.result)
        commit(SET_ENTITIES, normalized.entities)
    },
    async [CREATE_SESSION]({ commit }, loginData) {
        const data = await api.post('/session', qs.stringify(loginData), {
            withCredentials: true,
        })

        const normalized = normalize(data, schema.user)

        commit(SET_USER_ID, normalized.result)
        commit(SET_ENTITIES, normalized.entities)
        return normalized.result
    },

    async [DELETE_SESSION]({ commit }) {
        await api.delete('/session')

        commit(SET_USER_ID, null)
    },

    async [READ_POSITIONS]({ commit }, query) {
        const data = await api.get(
            `/positions?${qs.stringify(query, { indices: false })}`
        )

        const normalized = normalize(data, [schema.position])

        commit(SET_ENTITIES, normalized.entities)
    },
    async [READ_GEOFENCES]({ commit }) {
        const data = await api.get(
            `/geofences?userId=3`
        )

        // const normalized = normalize(data, [schema.geofences])

        commit(SET_GEOFENCES, data)
    },
    [UPDATE_AWARDED_DEVICES]({ commit, getters }, deviceId) {
        let awardedDeviceIds = getters.awardedDeviceIds

        if (awardedDeviceIds.includes(deviceId)) {
            awardedDeviceIds.splice(awardedDeviceIds.indexOf(deviceId), 1)

            commit(SET_AWARDED_DEVICES, awardedDeviceIds)
        } else {
            awardedDeviceIds.push(deviceId)

            commit(SET_AWARDED_DEVICES, awardedDeviceIds)
        }
    },
    async [READ_COMPETITION_TRACKPOINTS]({ commit }, id) {
        const data = await apiDostartu.get(`/competitions/${id}/trackpoints`)

        const normalized = normalize(data, [schema.trackpoint])

        commit(SET_ENTITIES, normalized.entities)

        return normalized.result
    },
    async [READ_CLASSIFICATION_GPX_FILE]({ commit }, id) {
        const data = await apiDostartu.get(`/classifications/${id}/gpx-link`)
        const isGPXFileValid = await validateGPXFileFromURL(data)
        const gpxFile = {
            classification: id,
            url: isGPXFileValid ? data : null,
        }
        const normalized = normalize(gpxFile, schema.gpxFile)

        commit(SET_ENTITIES, normalized.entities)

        return normalized.result
    },
    async [READ_COMPETITION]({ commit }, id) {
        const data = await apiDostartu.get(`/competitions/${id}`)

        const normalized = normalize(data, {
            competition: schema.competition,
            competitionLayout: schema.competitionLayout,
        })

        commit(SET_ENTITIES, normalized.entities)

        return normalized.result
    },
    async [READ_COMPETITION_CLASSIFICATIONS]({ commit }, id) {
        const data = await apiDostartu.get(
            `/competitions/${id}/classifications`
        )

        const normalized = normalize(data, {
            classifications: [schema.classification],
        })

        commit(SET_ENTITIES, normalized.entities)

        return normalized.result
    },
    async [READ_LOCATION]({ commit }, id) {
        const data = await apiDostartu.get(`/locations/${id}`)

        const normalized = normalize(data, schema.location)

        commit(SET_ENTITIES, normalized.entities)

        return normalized.result
    },
    async [READ_PLAYERS]({ commit }, id) {
        // commit(SET_APP_STATUS, 'Wyszukiwanie zawodników...')
        let players = []
        const data = await apiDostartu.get(`/competitions/${id}/gps`)
        if (data.length === 0) {
            commit(SET_APP_STATUS, { isError: true, message: 'Nie znaleziono zawodników' })
        }
        data.forEach((playerInfo, idx) => {
            let player = {
                deviceColor: `hsla(${(idx * 137.508) % 360}, 100%, 60%, 1)`,
                deviceId: playerInfo.gps.trackerId,
                trackNumber: playerInfo.gps.number,
                specialName: playerInfo.specialName,
                ...playerInfo.player,
            }
            players.push(player)
        })

        const normalized = normalize(players, [schema.player])

        commit(SET_ENTITIES, normalized.entities)

        return normalized.result
    },
    async [READ_SUMMARY_DEVICE]({ commit }, query) {
        const data = await api.get(
            `/reports/summary?${qs.stringify(query, { indices: false })}`
        )
        const normalized = normalize(data, [schema.deviceSummary])

        commit(SET_ENTITIES, normalized.entities)

        return normalized.result
    },
    async [READ_ROUTE](store, query) {
        const data = await api.get(
            `/positions?${qs.stringify(query, { indices: false })}`,
            {
                headers: {
                    Accept: 'application/gpx+xml',
                },
            }
        )
        return data
    },
    async [READ_GEOJSON_REPLAY](state, query) {
        const data = await apiAP.get(
            `/geoJson_online.php?${qs.stringify(query, { arrayFormat: 'indices' })}`,
        )
        let featureCollection = data.filter(
            feature => feature.properties.time.length
        )

        return featureCollection
    },

    async [READ_EVENT_TIMES_DATA]({ commit }, competitionId) {
        try {
            const response = await apiAP.get(`/event.php?event_id=${competitionId}`);
            commit(SET_EVENT_TIMES_DATA, response);
            commit(SET_SELECTED_SERIE_NUMBER, null);

        } catch (e) {
            console.error('Błąd przy pobieraniu danych eventTimeData:', e);
        }
    },
}
